export const UPDATE_THANKYOU_INITIAL_DATA = 'UPDATE_THANKYOU_INITIAL_DATA';
export const UPDATE_THANKYOU_DATA = 'UPDATE_THANKYOU_DATA';
export const UPDATE_THANKYOU_LOADING_STATUS = 'UPDATE_THANKYOU_LOADING_STATUS';
